<template src="./Modal.html"></template>
<script>
import { serverBus } from "../../main";
import Icono from "../Icono/Icono";
import { setTimeout } from "timers";
var json;
export default {
  data() {
    return {
      estadoModal: true,
      dialogoModal:false,
      dialog: false,
      iconoCerrar:
        "M43.7,42.3c0.4,0.4,0.4,1,0,1.4C43.5,43.9,43.3,44,43,44s-0.5-0.1-0.7-0.3L22,23.4L1.7,43.7C1.5,43.9,1.3,44,1,44s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4L20.6,22L0.3,1.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L22,20.6L42.3,0.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L23.4,22L43.7,42.3z",
      iconoHecho:
        "M22,44C9.9,44,0,34.1,0,22S9.9,0,22,0s22,9.9,22,22S34.1,44,22,44z M22,2C11,2,2,11,2,22s9,20,20,20s20-9,20-20S33,2,22,2zM17.7,30.7l16-16c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0L17,28.6l-6.3-6.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l7,7c0.2,0.2,0.5,0.3,0.7,0.3S17.5,30.9,17.7,30.7z",
      iconoAlerta:
        "M22,44C9.9,44,0,34.1,0,22S9.9,0,22,0s22,9.9,22,22S34.1,44,22,44z M22,2C11,2,2,11,2,22s9,20,20,20s20-9,20-20S33,2,22,2zM22,27c-0.5,0-0.9-0.3-1-0.8l-3.1-14.1c-0.3-1.3,0-2.5,0.8-3.5c0.8-1,2-1.6,3.3-1.6s2.5,0.6,3.3,1.6c0.8,1,1.1,2.3,0.8,3.5L23,26.2C22.9,26.7,22.5,27,22,27z M22,9c-0.7,0-1.3,0.3-1.7,0.8s-0.6,1.2-0.4,1.9l2.2,9.7l2.2-9.7c0.1-0.7,0-1.3-0.4-1.9S22.7,9,22,9zM22,37c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S24.2,37,22,37z M22,31c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S23.1,31,22,31z"
    };
  },
  components: {
    Icono,
  },
  created() {
    this.$emit('actualizarOpcion', '') 
    // Tiempo para que el modal se cierre, y qu e cuando le de a la 'X' se resetee el setTimeout
    setTimeout(() => {
      if (this.estadoModal&&!this.dialogoModal) {
        this.estadoModal = false;
        this.$store.dispatch("cambiarEstadoModal", false);
      }
    }, 10000);
  },
  methods: {
    cambiarEstadoModal(estado) {
      this.estadoModal = estado;
      this.$store.dispatch("cambiarEstadoModal", estado);
    },
    opcionSeleccionada(opcion) {
      this.$emit('actualizarOpcion', opcion) 
      this.$store.dispatch("cambiarEstadoModal", false);
    }
  },
  computed: {
    cambiarMensajeModal() {
      if(this.$store.getters.getMensajeModal.dialogo){
          this.dialogoModal=true
      }
      return this.$store.getters.getMensajeModal;
    },
    cambiarIconoModal() {
      return this.$store.getters.getIconoModal;
    }
  }
};
</script>
<style lang="scss" scoped src='./Modal.scss'></style>


// WEBPACK FOOTER //
// src/components/Modal/Modal.vue